import { Component, Input, OnInit } from '@angular/core';
import { AuthService, GenesisUnitOfWork } from 'app/core/core.module';
import { Note } from 'app/core/model/note';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-dealer-note-dialog',
    templateUrl: './dealer-note-dialog.component.html',
    styleUrls: ['./dealer-note-dialog.component.scss'],
    standalone: false,
})
export class DealerNoteDialogComponent implements OnInit {
    result: Subject<{ success: boolean; value?: Note }> = new Subject();
    dealers: any[] = [];
    // dealerId: any;
    processing = false;
    noteText: string = '';
    note: Note | null = null;

    @Input() dealerId: string;
    dealerFieldDisabled = false;

    constructor(public modalRef: BsModalRef, private uow: GenesisUnitOfWork, private auth: AuthService) {}

    async ngOnInit() {
        const dealers = await this.uow.getDealerInfos();
        dealers.forEach((dealer) => {
            dealer.id = dealer.id.toString(); // Ensure dealer ID is a string
        });
        this.dealers = dealers;

        if (!this.note) {
            this.note = this.uow.notes.createEntity({
                created: new Date(),
                createdBy: this.auth.currentUser.userName,
                notes: '',
                entityTypeName: 'Dealer',
                primaryKey: '',
            }) as Note;
        }

        if (this.dealerId) {
            this.note.primaryKey = this.dealerId;
            this.dealerFieldDisabled = true;
        }
    }

    async save() {
        this.processing = true;
        await this.uow.commit();

        this.result.next({ success: true });
        this.modalRef.hide();
    }

    close() {
        this.uow.rollback();
        this.result.next({ success: false });
        this.modalRef.hide();
    }
}
